import Button from '@material-ui/core/Button';
import React from 'react';
import { Alert, Styles } from '../Tools';
import Paper from '@material-ui/core/Paper';
import TextField from '@material-ui/core/TextField';
import { useFormik } from 'formik';
import * as yup from 'yup';
import { Device } from '../../types/api/responses';
import Container from '@material-ui/core/Container';
import { newDevice, resetNewDevice, updateDevice } from 'redux/actions/devices.actions';
import { useThunkDispatch, useTypedSelector } from 'hooks';
import CircularProgress from '@material-ui/core/CircularProgress';
import { Save } from '@material-ui/icons';

const validationSchema = yup.object({
  imei: yup
    .string()
    .trim()
    .required('IMEI es obligatorio')
    .min(16, 'El IMEI debe tener 16 caracteres')
    .max(16, 'El IMEI debe tener 16 caracteres')
    .matches(/[0-9]{16}/),
  number: yup
    .string()
    .trim()
    .min(8, 'el numero debe contener 8 caracteres')
    .max(8, 'el numero debe contener 8 caracteres')
    .matches(/[0-9]{8}/, 'Solo se permiten números'),
  manufacture: yup.string().trim().max(35, 'Maximo 35 caracteres'),
  model: yup.string().trim().max(100, 'Maximo 100 caracteres'),
});

export function NewDevice({
  device,
  isNew,
  handleClose,
  onSubmitFinish,
  setMessageSnackbar,
}: {
  device: Device;
  isNew: boolean;
  setMessageSnackbar?: (state: {
    open: boolean;
    message: string;
    severity: 'error' | 'warning' | 'info' | 'success';
  }) => void;
  onSubmitFinish?: () => void;
  handleClose: (loading: boolean | null, flag: boolean) => void;
}) {
  const classes = Styles();
  const devices = useTypedSelector((z) => z.devices);
  const dispatch = useThunkDispatch();

  const isExistDevice = (imei: string) => {
    return devices.devices.devices.find((d) => d.imei === imei) && isNew;
  };
  const formik = useFormik({
    initialValues: {
      imei: device.imei,
      manufacture: device.manufacture,
      model: device.model,
      number: device.number,
    },
    validationSchema: validationSchema,
    onSubmit: async (values) => {
      if (isNew) {
        const result = await dispatch(
          newDevice({
            imei: values.imei.trim(),
            manufacture: values.manufacture ? values.manufacture.trim() : null,
            model: values.model ? values.model.trim() : null,
            enable: true,
            number: values.number ? values.number.trim() : null,
            assigned: null,
          }),
        );

        if (!Boolean(result)) {
          setMessageSnackbar?.({
            open: true,
            message: 'Error al guardar el Dispositivo',
            severity: 'error',
          });
          return;
        }

        setMessageSnackbar?.({
          open: true,
          message: 'Se guardo con exito el Dispositivo',
          severity: 'success',
        });
      } else {
        const result = await dispatch(
          updateDevice({
            imei: values.imei.trim(),
            manufacture: values.manufacture ? values.manufacture.trim() : null,
            model: values.model ? values.model.trim() : null,
            enable: true,
            number: values.number ? values.number.trim() : null,
            assigned: null,
          }),
        );

        if (!Boolean(result)) {
          setMessageSnackbar?.({
            open: true,
            message: 'Error al editar el Dispositivo',
            severity: 'error',
          });
          return;
        }
        setMessageSnackbar?.({
          open: true,
          message: 'Se edito con exito el Dispositivo',
          severity: 'success',
        });
      }

      onSubmitFinish?.();
    },
  });

  const handleAcepting = () => {
    dispatch(resetNewDevice());
    handleClose(false, false);
  };

  const saveIn = (
    <Button
      type="submit"
      fullWidth
      variant="contained"
      color="primary"
      className={classes.submit}
      startIcon={<Save />}
      disabled={isExistDevice(formik.values.imei)}

    >
      Guardar
    </Button>
  );


  return (
    <Container className={classes.paper}>
      <form onSubmit={formik.handleSubmit} className={classes.form}>
        <Paper
          className={classes.paper}
          style={{ backgroundColor: '#343c89', color: 'white' }}
        >
          <h2>{isNew ? 'Creando Dispositivo' : 'Editando Dispositivo: ' + device.imei}</h2>
        </Paper>
        {isNew ? (
          <TextField
            onChange={formik.handleChange}
            label="IMEI"
            margin="normal"
            fullWidth
            id="imei"
            name="imei"
            autoFocus
            inputProps={{ maxLength: 16 }}
            value={formik.values.imei}
            error={
              (formik.touched.imei && Boolean(formik.errors.imei)) ||
              Boolean(devices.error?.name === '1009')
            }
            helperText={
              (formik.touched.imei && formik.errors.imei) ||
              (Boolean(devices.error?.name === '1009') && 'IMEI ya registrado')
            }
            variant="outlined"
          />
        ) : (
          <div />
        )}
        <TextField
          onChange={formik.handleChange}
          label="Marca"
          margin="normal"
          inputProps={{ maxLength: 35 }}
          fullWidth
          id="manufacture"
          name="manufacture"
          value={formik.values.manufacture}
          error={formik.touched.manufacture && Boolean(formik.errors.manufacture)}
          helperText={formik.touched.manufacture && formik.errors.manufacture}
          variant="outlined"
        />
        <TextField
          onChange={formik.handleChange}
          label="modelo"
          margin="normal"
          inputProps={{ maxLength: 150 }}
          fullWidth
          id="model"
          name="model"
          value={formik.values.model}
          error={formik.touched.model && Boolean(formik.errors.model)}
          helperText={formik.touched.model && formik.errors.model}
          variant="outlined"
        />
        <TextField
          onChange={formik.handleChange}
          label="Numero"
          margin="normal"
          fullWidth
          id="number"
          inputProps={{ maxLength: 8 }}
          name="number"
          value={formik.values.number}
          error={formik.touched.number && Boolean(formik.errors.number)}
          helperText={formik.touched.number && formik.errors.number}
          variant="outlined"
        />
        {isExistDevice(formik.values.imei) && (
          <div>
            <Alert severity="error">El dispositivo ya existe</Alert>
            <br />
          </div>
        )}

        <div>
          {devices.isLoading ? (
            <div>
              <CircularProgress />
            </div>
          ) : (
            <div>
              {<div style={{ display: 'flex', flexDirection: 'column' }}>{saveIn}</div>}
            </div>
          )}
        </div>
      </form>
    </Container>
  );
}
